/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MergeCounselorDocumentsRequestItem } from './MergeCounselorDocumentsRequestItem';
import {
    MergeCounselorDocumentsRequestItemFromJSON,
    MergeCounselorDocumentsRequestItemFromJSONTyped,
    MergeCounselorDocumentsRequestItemToJSON,
    MergeCounselorDocumentsRequestItemToJSONTyped,
} from './MergeCounselorDocumentsRequestItem';

/**
 * 
 * @export
 * @interface MergeCounselorDocumentsRequest
 */
export interface MergeCounselorDocumentsRequest {
    /**
     * 
     * @type {Array<MergeCounselorDocumentsRequestItem>}
     * @memberof MergeCounselorDocumentsRequest
     */
    items: Array<MergeCounselorDocumentsRequestItem>;
}

/**
 * Check if a given object implements the MergeCounselorDocumentsRequest interface.
 */
export function instanceOfMergeCounselorDocumentsRequest(value: object): value is MergeCounselorDocumentsRequest {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function MergeCounselorDocumentsRequestFromJSON(json: any): MergeCounselorDocumentsRequest {
    return MergeCounselorDocumentsRequestFromJSONTyped(json, false);
}

export function MergeCounselorDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeCounselorDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MergeCounselorDocumentsRequestItemFromJSON)),
    };
}

export function MergeCounselorDocumentsRequestToJSON(json: any): MergeCounselorDocumentsRequest {
    return MergeCounselorDocumentsRequestToJSONTyped(json, false);
}

export function MergeCounselorDocumentsRequestToJSONTyped(value?: MergeCounselorDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(MergeCounselorDocumentsRequestItemToJSON)),
    };
}

